import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMember } from '../contexts/MemberContext';

const MemberProtectedRoute = ({ children }) => {
  const { isMember, isLoading } = useMember();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-slate-300 border-t-sage-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isMember) {
    return <Navigate to="/login" replace state={{ from: location.pathname, reason: 'membership_required' }} />;
  }

  return children;
};

export default MemberProtectedRoute;
